// activity的所有routes here

const CheckVersion = () => import('../../views/checkVersion/Index.vue')
const WinterVacationActivity = () => import('../../views/activity/winterVacation/WinterVacationActivity.vue')
const WinterVacationActivityMq = () => import('../../views/activity/winterVacation/WinterVacationActivityMq.vue')
const WinterVacationHomeworkReport = () =>
  import('../../views/activity/winterVacation/WinterVacationHomeworkReport.vue')

const ActivityWinners = () => import('../../views/activity/winners/Index.vue')

export default [
  {
    path: '/activity/check-version',
    name: 'activity_check_version',
    component: CheckVersion,
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/activity/nationalcup',
    name: 'activity_nationalcup',
    component: () => import('../../views/activity/nationalcup/Index.vue'),
  },
  {
    path: '/activity/winter-vacation',
    name: 'activity_winter_vacation',
    component: WinterVacationActivity,
  },
  {
    path: '/activity/winter-vacation-mq',
    name: 'activity_winter_vacation_mq',
    component: WinterVacationActivityMq,
  },
  {
    path: '/activity/winter-vacation-homework-report',
    name: 'activity_winter_vacation_homework_report',
    component: WinterVacationHomeworkReport,
    props: (route: any) => ({ ...route.query, ...route.params }),
  },
  {
    path: '/activity/winners',
    name: 'activity_winners',
    component: ActivityWinners,
    props: (route: any) => ({ ...route.query, ...route.params }),
    meta: {
      title: '中奖名单公示',
    },
  },
]
